module.exports = __webpack_public_path__ + "static/media/video_1.7ec49fdf.mp4";